import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import {
  SmartAccountTitleText, gilroyGeneratingImage,
  greyColor, maxMobile, maxTablet, maxWidth, primaryFont, retina, scrollbar, smMobile, wMedium,
} from 'Utils/utilsStyle';
import { FormQuestion, UpdateAccountPlanForm } from 'Types/CompaniesTypes';
import SmartInputAddIcon from 'Components/common/assets/svgIcons/SmartInputAddIcon';
import SmartInputRemoveIcon from 'Components/common/assets/svgIcons/SmartInputRemoveIcon';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { useDispatch, useSelector } from 'react-redux';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import { selectAccountDesignations, selectDesignationsLoading } from 'Selector/CompaniesSelector';
import { actions } from 'Slice/CompaniesSlice';
import { Spin } from 'antd';
import SmartInput from './SmartInput';

const Wrapper = styled.div`
  &.productCategory {
    /* .smart-heading-title-tooltip {
      .global-tooltip-element {
        position: relative;
        display: inline-flex;
        .section-detail-tip {
          .ant-tooltip {
            left: unset !important;
            right: unset !important;
            top: 10px !important;
          }
        }
      }
    }
    .smart-account-input {
      .text-area-smart {
        margin-bottom: 15px;
        height: 38px;
      }
    } */
    .smart-heading-title-tooltip {
      .global-tooltip-element {
        margin-right: -15px;
      }
    }
    .smart-account-input {
      .text-area-smart {
        margin-bottom: 32px;
        height: 38px;
      }
    }
  }
  &.productDescription{
    .smart-heading-title-tooltip {
      display: flex;
      justify-content: space-between;
      .global-tooltip-element {
        margin-right: -15px;
      }
    }
  }
  display: flex;
  flex-direction: column;
  .smart-heading-title-tooltip {
    display: flex;
    width: calc(100% - 15px);
    ${SmartAccountTitleText};
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
      line-height: 18px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      line-height: 16px;
    }
    margin-bottom: 12px;
    .global-tooltip-element {
      position: relative;
      display: inline-flex;
      .section-detail-tip {
        .ant-tooltip {
          left: unset !important;
          right: 25px !important;
          top: 10px !important;
        }
      }
    }
  }
  .multi-inputs-div {
    &.loaderForMultiInputs {
      height: calc(100vh - 500px);
      display: flex;
      align-items: center;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: calc(100vh - 400px);
      }
    }
    &.withoutTabsMultiInputs {
       max-height: calc(100vh - 402px);
      @media all and (max-width: ${maxWidth}), ${retina} {
        max-height: calc(100vh - 325px);
      }
    }
    width: calc(100% - 9px);
    max-height: calc(100vh - 410px);
    @media all and (max-width: ${maxWidth}), ${retina} {
      max-height: calc(100vh - 347px);
    }
    @media all and (max-width: ${maxTablet}) {
      max-height: calc(100vh - 402px);
    }
    @media all and (max-width: ${smMobile}) {
      max-height: calc(100vh - 420px);
    }
    ${scrollbar};
    border-radius: 0px !important;
    padding-right: 10px;
    .smart-input-add-div {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .smart-account-input {
        width: calc(100% - 24px);
        .text-area-smart {
          height: 38px;
          padding: 7px 10px;
        }
      }
      svg {
        width: 18px;
        height: 18px;
        margin-left: 6px;
        cursor: pointer;
        &.disabled {
          cursor: none;
          opacity: 0.6;
        }
      }
    }
    .designation-loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 65px;
      @media all and (max-width: ${smMobile}) {
        padding: 0 25px;
      }
      .ant-spin {
        width: 48px;
        height: 47px;
        margin-bottom: 8px;
      }
      .paragraph-loader {
        color: ${greyColor};
        text-align: center;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 18px;
        letter-spacing: -0.562px;
        margin-bottom: 10px;
      }
      .generating-img {
        width: 148px;
        height: 134px;
        flex-shrink: 0;
        @media all and (max-width: ${smMobile}) {
          width: 128px;
          height: 114px;
        }
      }
    }
  }
`;

type Props = {
  questionData: FormQuestion,
  handleQuestionAns: (a: UpdateAccountPlanForm) => void,
  textAreaRows?: number,
  multiInputs?: boolean,
  currentSlide?: number,
  isNotBuyerCommeittee?: boolean,
  isDesignationsAPI?: boolean,
  setIsNotBuyerCommeittee?: (a: boolean) => void,
  isActive?: boolean,
  questionIndex?: number,
} & typeof defaultProps;

const defaultProps = {
  textAreaRows: 10,
  multiInputs: false,
  currentSlide: 0,
  isNotBuyerCommeittee: false,
  isDesignationsAPI: false,
  isActive: false,
  questionIndex: 0,
  setIsNotBuyerCommeittee: (a: boolean) => {
    console.log(a);
  },
};

const SmartQuestionAnswerComponent = function SmartQuestionAnswerComponent(props: Props) {
  const {
    questionData, handleQuestionAns, textAreaRows, isActive, questionIndex,
    multiInputs, currentSlide, isNotBuyerCommeittee, isDesignationsAPI, setIsNotBuyerCommeittee,
  } = props;
  const [value, setValue] = useState(questionData?.userInput || '');
  const [multiValues, setMultiValues] = useState(['']);
  const inputRefs = useRef<Array<HTMLTextAreaElement | null>>([]);
  const prevMultiValue = usePrevious(multiValues);
  const designationLoading = useSelector(selectDesignationsLoading);
  const designations = useSelector(selectAccountDesignations);

  const dispatch = useDispatch();
  const startTime = getCurrentTime();

  useEffect(() => {
    setMultiValues(designations);
  }, [designations]);

  useEffect(() => {
    handleQuestionAns({
      id: questionIndex,
      questionStatement: questionData.statement,
      userInput: value,
    });
  }, [value]);

  useEffect(() => {
    if (multiInputs) {
      handleQuestionAns({
        questionStatement: questionData.statement,
        userInput: multiValues,
      });
    }
  }, [multiValues]);

  const handleMultiValue = (multiValue: string, index: number) => {
    const updatedItems = [...multiValues];
    updatedItems[index] = multiValue;
    setMultiValues(updatedItems);
  };

  const handleAddDesignation = (isEnter?: boolean) => {
    if (isNotBuyerCommeittee) {
      setIsNotBuyerCommeittee(false);
    }
    dispatch(actions.setDesignationsLoaded(false));
    if (multiValues.length < 51) {
      const designationName = multiValues[multiValues.length - 1];
      if (designationName.trim().length) {
        setMultiValues([...multiValues, '']);
        dispatch(actions.updateDesignations([...multiValues, '']));
        inputRefs?.current[multiValues.length - 1]?.focus();
        if (inputRefs.current[multiValues.length]) {
          inputRefs?.current[multiValues.length]?.focus();
        }
        const flurryEvent = isEnter ? `accountplan_enteredDesignation_${designationName}` : `accountplan_addedDesignation_${designationName}`;
        dispatch(flurryActions.callFlurryEvent(
          valueToObject(flurryEvent, startTime, {}),
        ));
      }
    } else {
      dispatch(flurryActions.setNotification({
        message: 'Can add up to 50 designations only',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  };

  const handleRemoveDesignation = (index: number) => {
    dispatch(actions.setDesignationsLoaded(false));
    const updatedItems = [...multiValues];
    const designation = updatedItems[index];
    updatedItems.splice(index, 1);
    setMultiValues(updatedItems);
    dispatch(actions.updateDesignations(updatedItems));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`accountplan_removedDesignation_${designation}`, startTime, {}),
    ));
  };

  useEffect(() => {
    const focusLastInput = () => {
      inputRefs?.current[multiValues.length - 1]?.focus();
    };
    if (prevMultiValue && prevMultiValue?.length < multiValues.length) {
      focusLastInput();
    }
  }, [multiValues]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>, index: number) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (index === multiValues.length - 1) {
        handleAddDesignation(true);
      }
    }
  };
  const handleInputRef = (ref: HTMLTextAreaElement | null, index: number): void => {
    if (currentSlide === 1 && !isNotBuyerCommeittee && !isDesignationsAPI) {
      setIsNotBuyerCommeittee(true);
      inputRefs.current[index] = ref;
    }
  };

  return (
    <Wrapper className={classNames('smart-account-budget', { productCategory: textAreaRows === 1 }, { productDescription: questionIndex === 2 }, { dNone: !isActive })}>
      <h1 className="smart-heading-title-tooltip">
        {questionData?.statement}
        {questionData?.optional === 0 ? '*' : ''}
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={questionData?.tooltip}
          exampleText={questionData?.example}
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </h1>
      {multiInputs ? (
        <div className={classNames('multi-inputs-div', {
          loaderForMultiInputs: designationLoading,
          // withoutTabsMultiInputs: true, // remove after tabs development
        })}
        >
          {!designationLoading
            ? multiValues?.map((multiValue, index) => (
              <div className="smart-input-add-div">
                <SmartInput
                  multiInput
                  value={multiValue}
                  handleInputChange={(e) => handleMultiValue(e, index)}
                  placeholderText={questionData?.placeholder}
                  noOfRows={1}
                  handleKeyDown={(e) => handleKeyDown(e, index)}
                  inputRef={(ref) => handleInputRef(ref, index)}
                />
                {index === multiValues.length - 1
                  ? <SmartInputAddIcon className={classNames('', { disabled: multiValues[index].trim().length === 0 })} onClick={() => handleAddDesignation(false)} />
                  : (
                    <SmartInputRemoveIcon
                      onClick={() => handleRemoveDesignation(index)}
                    />
                  )}
              </div>
            ))
            : (
              <div className="designation-loader">
                <Spin />
                <p className="paragraph-loader">Please wait, while we recommend you the designations for Buyer Committee.</p>
                {currentSlide === 3 ? <img src={gilroyGeneratingImage} className="generating-img" alt="generating-gilroy" /> : null}
              </div>
            )}
        </div>
      ) : (
        <SmartInput
          value={value}
          handleInputChange={setValue}
          placeholderText={questionData?.placeholder}
          noOfRows={textAreaRows}
        />
      )}
    </Wrapper>
  );
};
SmartQuestionAnswerComponent.defaultProps = defaultProps;
export default SmartQuestionAnswerComponent;
